var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TFHero'),_c('TFProblem'),_c('TFSolution'),_c('TFPricing'),_c('TFCases'),_c('TFFAQ'),_c('TFContact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }